import React from "react"
import { DownloadAppStyle, Title } from "./DownloadMobileApp.style"
import Button from "../Button/Button"
import identifyOs from "../../utils/identifyOs"

const DownloadMobileApp = () => {
  const appLink =
    identifyOs() === "mac"
      ? "https://apps.apple.com/us/app/onecloud-meet/id1536805343"
      : "https://play.google.com/store/apps/details?id=com.telware.hdmeet&hl=en&gl=US"
  return (
    <DownloadAppStyle>
      <Title>For better experience download our mobile app</Title>
      <Button size="small" className="primary h-32" type="link" href={appLink}>
        Download
      </Button>
    </DownloadAppStyle>
  )
}

export default DownloadMobileApp
